import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { HelpCentrePageRoutingModule } from "./help-centre-routing.module";

import { HelpCentrePage } from "./help-centre.page";
import { SafeUrlPipe } from "../pipes/safe-url.pipe";

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, HelpCentrePageRoutingModule],
  declarations: [HelpCentrePage, SafeUrlPipe],
  exports: [SafeUrlPipe],
})
export class HelpCentrePageModule {}
